module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo22.42f4a8e8.jpg";